import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  RestaurantIssue,
  RestaurantIssuesState,
} from "../../types/restaurantIssues";
import {
  fetchAllRestaurantIssues,
  fetchRestaurantIssues,
  updateRestaurantIssue,
} from "../thunk";

const initialState: RestaurantIssuesState = {
  issues: [],
  loading: false,
  error: null,
  selectedIssue: null,
};

const restaurantIssuesSlice = createSlice({
  name: "restaurantIssues",
  initialState,
  reducers: {
    setSelectedIssue: (state, action: PayloadAction<RestaurantIssue | null>) => {
      state.selectedIssue = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Fetch All Restaurant Issues
      .addCase(fetchAllRestaurantIssues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllRestaurantIssues.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        if (action.payload.success && action.payload.data) {
          state.issues = action.payload.data;
        }
      })
      .addCase(fetchAllRestaurantIssues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Fetch Restaurant Issues (by restaurant ID)
      .addCase(fetchRestaurantIssues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRestaurantIssues.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        if (action.payload.success && action.payload.data) {
          state.issues = action.payload.data;
        }
      })
      .addCase(fetchRestaurantIssues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Update Restaurant Issue
      .addCase(updateRestaurantIssue.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRestaurantIssue.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        if (action.payload.success && action.payload.data) {
          // Update the issue in the list
          const index = state.issues.findIndex(
            (issue) => issue._id === action.payload.data._id
          );
          if (index !== -1) {
            state.issues[index] = action.payload.data;
          }
          // Update selected issue if it's the one being updated
          if (state.selectedIssue?._id === action.payload.data._id) {
            state.selectedIssue = action.payload.data;
          }
        }
      })
      .addCase(updateRestaurantIssue.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setSelectedIssue, clearError, resetState } = restaurantIssuesSlice.actions;
export default restaurantIssuesSlice.reducer;
